import { FormQueryColumn } from '../use-form-app';

export default function buildFormColumns(columns: FormQueryColumn[]) {
  const formColumns: {
    repeatables: { [key: string]: FormQueryColumn[] },
    form: FormQueryColumn[]
  } = {
    repeatables: {},
    form: [],
  };

  for (const object of columns) {
    if (object.table_field) {
      if (!formColumns.repeatables[object.table_field]) {
        formColumns.repeatables[object.table_field] = [];
      }
      formColumns.repeatables[object.table_field].push(object);
    } else {
      // @ts-ignore
      formColumns.form.push(object);
    }
  }
  return formColumns;
}
